// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountFeature } from '@shared/utils/Account/AccountFeature';
import { Account } from '../../../cache/Account';
export class TvAccountTodaysResultData {
    constructor() {
        this.todaysGross = 0;
        this.todaysNet = 0;
        this.todaysFees = 0;
        this.todaysVolume = 0;
        this.todaysTrades = 0;
    }
    update(acc) {
        let isNeedUpdate = false;
        const todaysGross = Account.GetAccountFeature(AccountFeature.TodayGrossPNL, acc, acc.assetBalanceDefault);
        if (todaysGross !== this.todaysGross) {
            this.todaysGross = todaysGross;
            isNeedUpdate = true;
        }
        const todaysNet = Account.GetAccountFeature(AccountFeature.TodaysNetProfit, acc, acc.assetBalanceDefault);
        if (todaysNet !== this.todaysNet) {
            this.todaysNet = todaysNet;
            isNeedUpdate = true;
        }
        const todaysFees = Account.GetAccountFeature(AccountFeature.TodaysFee, acc, acc.assetBalanceDefault);
        if (todaysFees !== this.todaysFees) {
            this.todaysFees = todaysFees;
            isNeedUpdate = true;
        }
        const todaysVolume = Account.GetAccountFeature(AccountFeature.TodayVolume, acc, acc.assetBalanceDefault);
        if (todaysVolume !== this.todaysVolume) {
            this.todaysVolume = todaysVolume;
            isNeedUpdate = true;
        }
        const todaysTrades = Account.GetAccountFeature(AccountFeature.TodayTrades, acc, acc.assetBalanceDefault);
        if (todaysTrades !== this.todaysTrades) {
            this.todaysTrades = todaysTrades;
            isNeedUpdate = true;
        }
        return isNeedUpdate;
    }
}
